<template>
    <section>
        <transfer :user="user" :api_prefix="api_prefix"></transfer>
    </section>
</template>

<script>
import Transfer from "@/components/Transfer.vue";

export default {
  props: ['user', 'api_prefix'],
  data: function () 
  {
    return {}
  },
    components: {
        'transfer': Transfer,
    },
  methods:
  {
    
    },
}
</script>

<style scoped>
</style>